import React from "react";
import Reveal from "./Reveal";

/**
 * Sections are separated by a hairline rule rather than by floating cards.
 * `index` prints a small mono number so the page reads like a document.
 */
export const Band = ({ id, tint = false, flush = false, className = "", children }) => (
  <section
    id={id}
    className={[
      "band",
      tint ? "band--tint" : "",
      flush ? "band--flush" : "",
      className,
    ]
      .filter(Boolean)
      .join(" ")}
  >
    <div className="shell">{children}</div>
  </section>
);

/**
 * A section header on the editorial rail: number + label on the left,
 * headline and standfirst on the right.
 */
export const SectionHead = ({ index, label, title, children, action }) => (
  <div className="rail mb-12 md:mb-16">
    <div className="rail__label">
      <Reveal className="flex items-baseline gap-3 md:block">
        {index ? (
          <span className="num text-[11px] text-ink-3 md:mb-2 md:block">
            {String(index).padStart(2, "0")}
          </span>
        ) : null}
        <span className="eyebrow">{label}</span>
      </Reveal>
    </div>

    <div>
      <Reveal>
        <h2 className="title max-w-[20ch]">{title}</h2>
      </Reveal>
      {children ? (
        <Reveal delay={0.05}>
          <div className="subhead mt-5 max-w-prose">{children}</div>
        </Reveal>
      ) : null}
      {action ? (
        <Reveal delay={0.1}>
          <div className="mt-7">{action}</div>
        </Reveal>
      ) : null}
    </div>
  </div>
);

export default Band;
